import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { useCurrentBookingIncludesBundledMembership } from '@/booking-membership/hooks/use-current-booking-includes-bundled-membership.hook';
import { IRestaurantModelInstance } from '@/hotel/models/restaurant.model';
import { useTranslation } from '@/i18n';
import { useTheme } from '@/ui/theme';

import { MoreInfoCardSection } from './MoreInfoCardSection.component';

interface RestaurantsCardSectionProps {
  restaurants: IRestaurantModelInstance[];
  title?: string;
}

export const RestaurantsCardSection = observer(
  ({ restaurants, title }: RestaurantsCardSectionProps) => {
    const { t } = useTranslation();
    const {
      componentProperties: { confirmation },
    } = useTheme();

    const isMembershipEnabled = useCurrentBookingIncludesBundledMembership();

    return (
      <MoreInfoCardSection
        css={css({
          ...confirmation?.restaurantsCard,
          span: confirmation?.restaurantsCard?.restaurantDescription,
          h5: {
            span: confirmation?.restaurantsCard?.title,
          },
          h6: {
            span: confirmation?.restaurantsCard?.restaurantTitle,
          },
          ['@media all and (max-width: 730px)']: {
            ...confirmation?.restaurantsCard?.mobile,
            h5: {
              span: confirmation?.restaurantsCard?.title?.mobile,
            },
            h6: {
              span: confirmation?.restaurantsCard?.restaurantTitle?.mobile,
            },
          },
        })}
        title={title ?? t('restaurants:restaurantCardTitle')}
        description={
          isMembershipEnabled
            ? t('bookingMembership:confirmation.restaurants.description')
            : undefined
        }
        items={restaurants.map((restaurant) => ({
          name: restaurant.name,
          description: restaurant.description,
          image: restaurant.images[0],
          url: restaurant.publicUrl,
        }))}
      />
    );
  }
);
